import DefaultPage from '../default-page';


class HomePage extends DefaultPage {

}


export default HomePage;
